import React, { Component } from 'react'
import { withRouter } from 'react-router'
import URLUtils from '../../util/URLUtils'
import { Redirect } from 'react-router-dom'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import SpinnerPageUI from '../common/SpinnerPageUI'

class FBAuthReturnPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      response: null
    }
  }

  render() {
    if (!this.state.response)
      return (
        <SpinnerPageUI context={this.props.context} />
      )

    switch (this.state.response.statusCode) {
      case 'AuthTokenAlreadyUsed':
      case 'AuthTokenExpired':
      case 'UnknownError':
      case 'ParamatersMissing':
        return (
          <Redirect to='/pub/message?key=error' />
        )
      case 'DisconnectedAccountExists':
        return (
          <Redirect to={`/pub/link-user?provider=${this.state.response.provider}`} />
        )
      case 'LoggedInWithGBefore':
        return (
          <Redirect to='/pub/message?key=login_with_google' />
        )
      case 'AccessDenied':
        return (
          <Redirect to={`/pub/message?key=login_cancelled&arg=${this.state.response.provider}`} />
        )
      case 'EmailRequired':
        return (
          <Redirect to={`/pub/email-required?provider=${this.state.response.provider}&reRequestUrl=${encodeURIComponent(this.state.response.reRequestUrl)}`} />
        )
      default:
        return (
          <Redirect to='/' />
        )
    }
  }

/*
http://localhost:3000/pub/fbauth/return?code=AQBodM2vQSqh4msIJYaDr2Zew-VfAAKwVXu1sRvgTDQbk6bvmcInZpwA5yBPYIt-M1K6leYklZ9mJa4xIFPXrcbgMf9yq1iFwqJ0mgCanR5PSf9rRx2guwW_8gQhTJNUvTS2etBxGr6XbBXXhj6rjyzCaroPyKa_FpUgqIgCjow7roM-ogJmkjgmBFqOXvLGos-xIeY7WSNBFoTUCtP_AiboTf2SKM8t6dTBwXvLM9vwUIZLQIBbfbsb8pEmR_EuDBEhxzwYhAQN56FK89MimC7Ea2ni3EgGi0ZG3dUf_GRnfm0QMiYD6Fi5cVLA6OAV_Ow#_=_
*/
  componentDidMount() {
    let params = new URLSearchParams(window.location.search)
    if (params.has('code') || params.has('error')) {
      RestApiUtils.post(this.props.context,
        '/api/pub/fbLogin',
        this.onPostCallback, {
          code: params.get('code'),
          error: params.get('error'),
          errorReason: params.get('error_reason'),
          errorDescription: params.get('error_description'),
          baseUrl: URLUtils.getBaseURL()
        }
      )
    }

  }

  onPostCallback = (response) => {
    if (response.statusCode === 'Success') { // TODO replace url
      this.props.context.onLogin(response.session, true)
      return
    }
    this.setState({response: response})
  }
}

export default withRouter(FBAuthReturnPageSF)
